import { useMocks } from '../../shared/env';
import type { CheckBatchGateway } from './CheckBatchGateway';
import { HttpCheckBatchGateway } from './HttpCheckBatchGateway';
import { MockCheckBatchGateway } from './MockCheckBatchGateway';

export const checkBatchGateway: CheckBatchGateway = useMocks ? new MockCheckBatchGateway() : new HttpCheckBatchGateway();
export type { CheckBatchGateway } from './CheckBatchGateway';
export * from './types';
